import { useContext } from 'react';
import DPCConversationsContext from 'src/contexts/dpxConversations/dpxConversationsContext';

const useDPXConversations = () => useContext(DPCConversationsContext);

export default useDPXConversations;
